import { render, staticRenderFns } from "./FriendActivity.vue?vue&type=template&id=79c32326&scoped=true"
import script from "./FriendActivity.vue?vue&type=script&lang=js"
export * from "./FriendActivity.vue?vue&type=script&lang=js"
import style0 from "./FriendActivity.vue?vue&type=style&index=0&id=79c32326&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c32326",
  null
  
)

export default component.exports